import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { DoorClosed, Lock, Cctv, Wifi, Tv } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/components/shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CARDS = [
  { icon: DoorClosed, name: "Smart Doorbell Installation", price: "Starting at $125", desc: "Video doorbells installed and configured right." },
  { icon: Lock, name: "Smart Lock Installation", price: "Starting at $125", desc: "Keyless entry set up and synced to your phone." },
  { icon: Cctv, name: "Security Camera Installation", price: "Starting at $125", desc: "Per-camera pricing, remote viewing included." },
  { icon: Wifi, name: "Wi-Fi & Networking", price: "Starting at $125", desc: "Routers, mesh systems, and dead-zone elimination." },
];

export default function PopularServices() {
  const [featured, setFeatured] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings/public`)
      .then((r) => setFeatured(r.data.featured_service))
      .catch(() => null);
  }, []);

  return (
    <section className="py-16 px-6 max-w-6xl mx-auto" data-testid="popular-services">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-10">
        <div>
          <span className="text-xs font-mono uppercase tracking-widest text-[#d4af37]">Book in Minutes</span>
          <h2 className="font-display text-3xl sm:text-4xl uppercase tracking-tight text-white mt-1">Popular Home Services</h2>
        </div>
        <p className="text-xs text-zinc-500 font-mono">Transparent starting prices · Dallas–Fort Worth</p>
      </div>

      {featured?.visible && (
        <div className="rounded-2xl gold-border bg-gradient-to-r from-[#14141a] to-[#0d0d10] p-7 sm:p-10 mb-6 relative overflow-hidden" data-testid="featured-tv-card">
          <div className="absolute -right-10 -top-10 opacity-10">
            <Tv className="w-56 h-56 text-[#d4af37]" strokeWidth={0.6} />
          </div>
          <div className="relative flex flex-col sm:flex-row sm:items-center gap-6 justify-between">
            <div className="max-w-lg">
              <span className="text-[10px] font-mono uppercase tracking-widest text-[#d4af37]">Featured Service</span>
              <h3 className="font-display text-3xl sm:text-4xl uppercase text-white mt-1">{featured.headline}</h3>
              <p className="font-display text-xl text-[#d4af37] mt-2">{featured.subheadline}</p>
              <p className="text-[10px] font-mono uppercase tracking-widest text-zinc-400 mt-1">{featured.tagline}</p>
              <p className="text-xs text-zinc-400 leading-relaxed mt-3">{featured.description}</p>
            </div>
            <div className="flex flex-col gap-3 shrink-0">
              <Link to="/book" data-testid="featured-book-btn"
                className="px-8 py-4 rounded bg-gradient-to-r from-[#d4af37] to-[#e6ca65] text-black font-bold uppercase tracking-wider text-sm text-center hover:opacity-95 transition-opacity shadow-lg shadow-[#d4af37]/25">
                Book TV Mounting →
              </Link>
              <a href={PHONE_TEL} data-testid="featured-call-btn"
                className="text-center text-xs font-mono text-zinc-400 hover:text-[#d4af37] transition-colors">
                or call {PHONE_DISPLAY}
              </a>
            </div>
          </div>
        </div>
      )}

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {CARDS.map((c) => (
          <div key={c.name}
            data-testid={`popular-card-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="rounded-xl bg-[#121216] gold-border p-5 flex flex-col group hover:border-[#d4af37]/50 transition-colors">
            <c.icon className="w-7 h-7 text-[#d4af37] mb-4" strokeWidth={1.5} />
            <h3 className="text-sm font-semibold text-white leading-snug">{c.name}</h3>
            <p className="text-[#d4af37] font-mono text-xs mt-1.5">{c.price}</p>
            <p className="text-[11px] text-zinc-500 mt-2 leading-relaxed flex-1 hidden sm:block">{c.desc}</p>
            <Link
              to="/services"
              data-testid={`popular-book-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="mt-4 block text-center py-2 rounded border border-[#d4af37]/30 text-[10px] font-mono uppercase tracking-wider text-[#d4af37] group-hover:bg-[#d4af37] group-hover:text-black transition-colors"
            >
              Book Now
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}
